module.exports = __webpack_public_path__ + "assets/img/skill.1675db7b.png";